import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { HttpClient } from "@angular/common/http";
import { Observable, BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";
import { Resource } from '../models/models.lib';
import { FormModes } from '../common/constants.lib';
import { environment } from '../../environments/environment';

const { apiUrl } = environment;

export abstract class EnvironerResourceService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;

  constructor(
    private http: HttpClient,
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(): Observable<Resource[]> {
    this.loading = true;

    return this.http.get(encodeURI(`${apiUrl}/resource/all`))
      .pipe(
        map((response: any, i) => {
          // console.log('fetch:map:response: ', response, i);
          // let returning =<Resource[]>response; // response.map(r =>  Resource.create((r)));
          // console.log('fetch:map:response: ', returning);
          return <Resource[]>response;
        }),
        map(r => r.map(x => Resource.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class ResourceService extends EnvironerResourceService {

  constructor(
    http: HttpClient,
    private apiService: ApiService
  ) {
    super(http);
  }

  get() {
    return this.apiService.getHttpCall('resource/all', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`resource/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    delete p.id;
    return this.apiService.postHttpCallAsPromise('resource', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`resource/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`resource/${id}`, 'destroy');
  }

  deleteFile(id: number, dirName: string): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`file/${id}/${dirName}`);
  }

  addEdit(p: any, formMode: FormModes): Promise<any> {
    if (formMode === FormModes.NEW) {
      return this.add(p);
    } else {
      return this.update(p);
    }
  }

}

/**
 * {
    "id": 23,
    "title": "Test Document",
    "description": "Test Document",
    "url": "https://environer-dev.une.edu.au/getfile/23?path=resource/Test Document.pdf",
    "document_file_name": "Test Document.pdf",
    "key_words": "Test Document",
    "deleted": false
  },
 */
